/* ==========================================================================
   Mobile toolbar buttons (Filter / Price / Sort) -> open drawer on one panel
   ========================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mobile-facet-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const mobPrice = document.querySelector('.mobPriceFilter');
      const mobSort = document.querySelector('.mobSortFilter');
      const mobFilters = document.querySelectorAll('.mobFilter');
      const mobHeading = document.querySelector('.mobile-facets__heading');

      const show = (el, visible) => {
        if (el) el.style.display = visible ? 'block' : 'none';
      };

      if (btn.classList.contains('clickFilter')) {
        mobFilters.forEach((el) => show(el, true));
        show(mobPrice, false);
        show(mobSort, false);
        if (mobHeading) mobHeading.textContent = 'Filter';
      }

      if (btn.classList.contains('clickPrice')) {
        mobFilters.forEach((el) => show(el, false));
        show(mobPrice, true);
        show(mobSort, false);
        if (mobHeading) mobHeading.textContent = 'Price';
      }

      if (btn.classList.contains('clickSort')) {
        mobFilters.forEach((el) => show(el, false));
        show(mobPrice, false);
        show(mobSort, true);
        if (mobHeading) mobHeading.textContent = 'Sort';
      }

      const mainDetails = document.querySelector('menu-drawer details');
      if (mainDetails && !mainDetails.hasAttribute('open')) {
        mainDetails.querySelector('summary').click();
      }
    });
  });
});

/* ==========================================================================
   Price band checkboxes
   Checkbox ka native "input" event form tak jata hai aur (500ms debounce ke baad)
   submit hota hai. Ye "change" handler usse pehle hidden min/max set kar deta hai.
   ========================================================================== */
document.addEventListener('change', (event) => {
  const cb = event.target.closest && event.target.closest('.price-band__checkbox');
  if (!cb) return;

  const wrapper = cb.closest('[data-price-bands]');
  if (!wrapper) return;

  const minInput = wrapper.querySelector('.price-band__input--min');
  const maxInput = wrapper.querySelector('.price-band__input--max');
  if (!minInput || !maxInput) return;

  const boxes = Array.from(wrapper.querySelectorAll('.price-band__checkbox'));
  const indexOf = (b) => Number(b.dataset.index);
  const checkedIdx = boxes.filter((b) => b.checked).map(indexOf);

  const syncLabels = () => {
    boxes.forEach((b) => {
      const label = b.closest('.facet-checkbox');
      if (label) label.classList.toggle('active', b.checked);
    });
  };

  if (!checkedIdx.length) {
    minInput.value = '';
    maxInput.value = '';
    minInput.disabled = true;
    maxInput.disabled = true;
    syncLabels();
    return;
  }

  let lo = Math.min(...checkedIdx);
  let hi = Math.max(...checkedIdx);

  // Beech wala band untick kiya -> uske upar ke bands hata do
  const clicked = indexOf(cb);
  if (!cb.checked && clicked > lo && clicked < hi) hi = clicked - 1;

  // Shopify ek hi range leta hai, isliye lo..hi ke saare bands tick
  boxes.forEach((b) => {
    const i = indexOf(b);
    b.checked = i >= lo && i <= hi;
  });
  syncLabels();

  const first = boxes.find((b) => indexOf(b) === lo);
  const last = boxes.find((b) => indexOf(b) === hi);

  minInput.value = first.dataset.min;
  minInput.disabled = false;
  maxInput.value = last.dataset.max || '';
  maxInput.disabled = !maxInput.value; // "X+" band -> sirf gte jayega
});

/* ==========================================================================
   Heel height band checkboxes
   ========================================================================== */
document.addEventListener('change', (event) => {
  const cb = event.target.closest && event.target.closest('.heel-band__checkbox');
  if (!cb) return;

  const band = cb.closest('.heel-band');
  if (!band) return;

  band.querySelectorAll('.heel-band__input').forEach((input) => {
    input.disabled = !cb.checked;
  });
  const label = cb.closest('.facet-checkbox');
  if (label) label.classList.toggle('active', cb.checked);
});

/* ==========================================================================
   Band pills (heel height) — pill click par sirf wahi band untick hota hai
   ========================================================================== */
document.addEventListener('click', (event) => {
  const pill = event.target.closest('.js-band-pill-remove');
  if (!pill) return;
  event.preventDefault();

  const isMobilePill = Boolean(pill.closest('.active-facets-mobile'));
  const form =
    document.getElementById(isMobilePill ? 'FacetFiltersFormMobile' : 'FacetFiltersForm') ||
    document.getElementById('FacetFiltersFormMobile');
  if (!form) return;

  const cb = form.querySelector(`.heel-band__checkbox[data-band-key="${pill.dataset.bandKey}"]`);
  if (cb && cb.checked) {
    cb.click(); // native input + change events fire -> form submit
  } else {
    window.location.href = pill.href;
  }
});

/* ==========================================================================
   FacetFiltersForm
   ========================================================================== */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document
      .querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner')
      .forEach((spinner) => spinner.classList.remove('hidden'));

    const grid = document.getElementById('ProductGridContainer');
    const collection = grid ? grid.querySelector('.collection') : null;
    if (collection) collection.classList.add('loading');
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    if (FacetFiltersForm.abortController) FacetFiltersForm.abortController.abort();
    FacetFiltersForm.abortController = new AbortController();

    fetch(url, { signal: FacetFiltersForm.abortController.signal })
      .then((response) => response.text())
      .then((html) => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderAll(html, event);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.error('Facet fetch failed:', error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    if (FacetFiltersForm.abortController) FacetFiltersForm.abortController.abort();
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderAll(html, event);
  }

  static renderAll(html, event) {
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
  }

  static renderProductGridContainer(html) {
    const target = document.getElementById('ProductGridContainer');
    const source = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (!target || !source) return;

    target.innerHTML = source.innerHTML;
    target.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

    if (window.facetsAjaxinate && typeof window.facetsAjaxinate.destroy === 'function') {
      window.facetsAjaxinate.destroy();
    }
    if (typeof Ajaxinate === 'function' && document.querySelector('.ajaxinate-container')) {
      window.facetsAjaxinate = new Ajaxinate({
        container: '.ajaxinate-container',
        pagination: '#AjaxinatePagination',
        method: 'scroll',
        loadingText: 'Loading',
      });
    }
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (source && container) {
      container.innerHTML = source.innerHTML;
      container.classList.remove('loading');
    }
    if (source && containerDesktop) {
      containerDesktop.innerHTML = source.innerHTML;
      containerDesktop.classList.remove('loading');
    }

    document
      .querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner')
      .forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const selector =
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter';
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(selector);
    const facetDetailsElementsFromDom = document.querySelectorAll(selector);

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const jsFilter = event && event.target && event.target.closest ? event.target.closest('.js-filter') : null;
    const matchesId = (element) => (jsFilter ? element.id === jsFilter.id : false);

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
        return;
      }

      if (index > 0) {
        const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
        if (elementToRender.className === previousElementClassName) {
          const previous = document.getElementById(previousElementId);
          if (previous) {
            previous.after(elementToRender);
            return;
          }
        }
      }

      if (elementToRender.parentElement) {
        const anchor = document.querySelector(`#${elementToRender.parentElement.id} .js-filter`);
        if (anchor) anchor.before(elementToRender);
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && jsFilter && jsFilter.id) {
      FacetFiltersForm.renderCounts(countsToRender, jsFilter);
      FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(jsFilter.id));

      const newFacetDetailsElement = document.getElementById(jsFilter.id);
      if (newFacetDetailsElement) {
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? '.mobile-facets__close-button'
          : '.facets__summary';
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        const isTextInput = event.target.getAttribute && event.target.getAttribute('type') === 'text';
        // Band checkbox click par focus mat churao
        const isBand = event.target.closest && event.target.closest('.price-band__checkbox, .heel-band__checkbox');

        if (newElementToActivate && !isTextInput && !isBand) {
          newElementToActivate.focus({ preventScroll: true });
        }
      }
    }
  }

  static renderActiveFacets(html) {
    ['.active-facets-mobile', '.active-facets-desktop'].forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    ['.mobile-facets__open', '.mobile-facets__count', '.sorting'].forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const drawer = mobileForm ? mobileForm.closest('menu-drawer') : null;
    if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');
    if (sourceSummary && targetSummary) targetSummary.outerHTML = sourceSummary.outerHTML;

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');
    if (sourceHeaderElement && targetHeaderElement) targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');
    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    if (!target) return;
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');
    if (sourceFacetsList && targetFacetsList) targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      console.warn('No element found with ID "product-grid"');
      return [];
    }
    return [{ section: grid.dataset.id }];
  }

  createSearchParams(form) {
    // Disabled hidden inputs (price / heel) FormData me nahi aate
    const params = new URLSearchParams();
    for (const [key, value] of new FormData(form).entries()) {
      if (value === '' && key.startsWith('filter.v.price')) continue;
      params.append(key, value);
    }
    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    if (!form) return;

    if (form.id === 'FacetFiltersFormMobile') {
      this.onSubmitForm(this.createSearchParams(form), event);
      return;
    }

    const forms = [];
    document.querySelectorAll('facet-filters-form form').forEach((f) => {
      if (f.id === 'FacetSortForm' || f.id === 'FacetFiltersForm' || f.id === 'FacetSortDrawerForm') {
        const params = this.createSearchParams(f);
        if (params) forms.push(params);
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const href = event.currentTarget.href;
    const url = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);

    if (url === 'sort_by') {
      const queryString = window.location.search.slice(1);
      const newurl = queryString.replace(/(^|&)sort_by=[^&]*/, '').replace(/^&|&$/g, '');
      FacetFiltersForm.renderPage(newurl);
    } else {
      FacetFiltersForm.renderPage(url);
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.abortController = null;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/* ==========================================================================
   FacetRemove (pills / clear all)
   ========================================================================== */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (!facetLink) return;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
